import { ApiModelTransformerInterface } from '@hidat/huijs-api';
import { instanceToPlain, plainToClass } from 'class-transformer';

export class CtApiModelTransformer<T> implements ApiModelTransformerInterface {
  constructor(protected jsonClass: any) {}

  public fromApi = (jsonItem: object) => {
    const item = plainToClass(this.jsonClass, jsonItem, {
      excludeExtraneousValues: true,
    });
    return item as T;
  };

  public toApi = (item: unknown) => {
    const jsonObject = instanceToPlain(item, { excludePrefixes: ['_'] });
    return jsonObject;
  };
}
